import { network } from 'services/network';

export const getValidationActivitiesDrillDown = (params) => {
    return network.post('api/bo/getValidationActivitiesDrillDown', params).then((response) => {
        return response.data;
    });
};
